import { Component, OnInit, ViewChild, ElementRef, HostListener, computed } from '@angular/core';
import { Utils } from '../../../../shared/utils';
import { IMPORTS } from './_imports';
import { AuthService } from '../../../../services/auth.service';

@Component({
    selector: 'user-menu',
    templateUrl: './user-menu.component.html',
    styleUrl: './user-menu.component.scss',
    standalone: true,
    imports: IMPORTS
})
export class UserMenuComponent implements OnInit {
    // #region [ViewChild]
    @ViewChild('dropdownMenuRef') dropdownMenuRef: ElementRef;
    @ViewChild('headerButtonRef') headerButtonRef: ElementRef;
    // #endregion

    // #region [listeners]
    @HostListener('document:click', ['$event'])
    clickout(event) {
        if (this.dropdownMenuRef?.nativeElement?.classList.contains('show')) {
            if (!event.composedPath().includes(this.dropdownMenuRef.nativeElement)) {
                this.toggleMenu();
            }
        } else {
            if (event.composedPath().includes(this.headerButtonRef?.nativeElement)) {
                this.toggleMenu();
            }
        }
    }
    // #endregion

    // #region [Type props]
    Utils = Utils;
    // #endregion

    // #region [computeds]
    $currentUser = computed(() => this.authService.$user());
    $userName = computed(() => this.$currentUser()?.apelido || this.$currentUser()?.nome || '');
    $userEmail = computed(() => this.$currentUser()?.email || '');
    // #endregion

    constructor(
        private elementRef: ElementRef,
        public authService: AuthService
    ) { }

    ngOnInit() { }

    toProfile() {
        open('https://acessocidadao.es.gov.br/Perfil/Editar');
    }

    logout() {
        this.authService.logout();
    }

    toggleMenu() {
        this.dropdownMenuRef.nativeElement.classList.toggle('show');
    }

    // #region [===== private methods =====]
    // #endregion
}
